"use client";
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import NextLink from "next/link";
import { useTranslation } from "react-i18next";

const ZaynFaqsSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const faqs = t("zaynFaqs.items", { returnObjects: true }) || [];

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 6, md: 8 },
        bgcolor: "#fff",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "24px", sm: "28px", md: "32px" },
            fontWeight: 700,
            lineHeight: 1.3,
            color: "#14122B",
            fontFamily: "var(--font-plusjakarta)",
            textAlign: "center",
            mb: { xs: 3, sm: 4, md: 5 },
          }}
        >
          {t("zaynFaqs.title")}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 2, sm: 2.5 },
            alignItems: "stretch",
          }}
        >
          {faqs.map((faq, index) => {
            const isLastOdd =
              faqs.length % 2 !== 0 && index === faqs.length - 1;

            return (
              <Box
                key={index}
                sx={{
                  bgcolor: "#FFFFFF",
                  border: "1px solid #ECE9F7",
                  borderRadius: "12px",
                  px: { xs: 2.5, sm: 3 },
                  py: { xs: 2.5, sm: 3 },
                  textAlign: isArabic ? "right" : "left",
                  gridColumn: { xs: "1 / -1", md: isLastOdd ? "1 / -1" : "auto" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "15px" },
                    fontWeight: 700,
                    lineHeight: 1.4,
                    color: "#14122B",
                    fontFamily: "var(--font-plusjakarta)",
                    mb: 1.2,
                  }}
                >
                  {faq.question}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "12.5px", sm: "13px" },
                    color: "#65657A",
                    lineHeight: 1.7,
                    fontWeight: 400,
                    fontFamily: "var(--font-outfit)",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: { xs: 4, sm: 5 },
          }}
        >
          <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
            <Button
              component="a"
              sx={{
                bgcolor: "#7A2BF5",
                color: "#fff",
                px: { xs: 3, sm: 3.5 },
                py: { xs: 1, sm: 1.1 },
                borderRadius: "50px",
                textTransform: "none",
                fontSize: { xs: "13px", sm: "14px" },
                fontWeight: 600,
                fontFamily: "var(--font-outfit)",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#5F1FC7",
                  transform: "scale(1.03)",
                },
              }}
            >
              {t("zaynFaqs.cta")}
            </Button>
          </NextLink>
        </Box>
      </Container>
    </Box>
  );
};

export default ZaynFaqsSection;